module.exports = __webpack_public_path__ + "static/media/kfc-24-81.ec6cb43a.jpg";